import { Avatar, Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { variants } from '../../../variants/variants';
import GGbotGIF from '../../../assets/Gifs/bot.gif';
import { useLocation, useNavigate } from 'react-router-dom';
import { Verified } from '@mui/icons-material';

const GGbot = ({ content, handleProfileClick, style = {} }) => {
  const { pathname } = useLocation();
  const active = pathname.split('/')[2] === 'home';
  const navigate = useNavigate();

  const handleGGClick = () => {
    navigate('/home/gbot');
  };

  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      style={style}
      onClick={handleGGClick}
      sx={{
        p: 1,
        m: 1,
        mb: 0,
        pl: 0,
        borderBottom: 1,
        borderColor: 'divider',
        cursor: 'default',
        color: 'inherit',
        background: 'linear-gradient(180deg, #fff 10%,#EEF5FF 100% )',
        borderRadius: variants.boxRadius.SIDEBAR,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        animation: active ? 'pulse 1.5s infinite' : 'none',
        '@keyframes pulse': {
          '0%': {
            boxShadow: '0 0 0 0 rgba(0, 123, 178, 0.7)',
          },
          '70%': {
            boxShadow: '0 0 0 10px rgba(0, 123, 178, 0)',
          },
          '100%': {
            boxShadow: '0 0 0 0 rgba(0, 123, 178, 0)',
          },
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', zIndex: 1 }}>
        <Tooltip title={'GG bot coming soon...'}>
          <IconButton sx={{ p: 0, m: 0 }} size='medium'>
            <img
              src={GGbotGIF}
              style={{
                width: 40,
                height: 40,
                marginLeft: '0.3rem',
                borderRadius: '50%',
                border: '2px solid #03a9f4',
              }}
            />
          </IconButton>
        </Tooltip>
        <Box sx={{ ml: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography sx={{ fontSize: variants.BODY, fontWeight: 'bold', color: '#007bb2' }}>Linkway.gg</Typography>
            <Verified sx={{ color: '#03a9f4', ml: 1, fontSize: '18px' }} />
          </Box>
          <Typography sx={{ fontSize: variants.TINY, color: '#004d40' }}>Wondering what to do next...?</Typography>
        </Box>
      </Box>
      <Box>
        <Typography sx={{ fontSize: variants.TINY, color: '#004d40' }}>Coming soon...</Typography>
      </Box>
    </Stack>
  );
};

export default GGbot;
